import React from 'react'

import Header from '../Header'

import * as S from './styles'

type StepProps = {
  hasProducts?: boolean
  isLastStep?: boolean
  children: React.ReactNode
}

const Step = ({
  children,
  hasProducts = false,
  isLastStep = false
}: StepProps) => {
  return (
    <S.Step>
      <Header hasProducts={hasProducts} isLastStep={isLastStep} />

      {children}
    </S.Step>
  )
}

export default Step
